import { fetchUserProfile } from '../../lib/services/mobivers/api';
import {
	fetchUserToken,
	refreshUserToken,
	requestBackofficeSSO,
} from '../../lib/services/mobivers/auth';
import {
	AppStore,
	DispatchFetchProfile,
	DispatchLogUser,
	DispatchThunkAny,
} from '../../types/redux';
import { log } from '../../utils/logger';
import { FETCH_CUSTOMIZING_SUCCESS, updateCustomizing } from './customizing';
import { deleteCookieWithName } from "../../utils/cookie";

export const LOG_USER_SUCCESS = 'LOG_USER_SUCCESS';
export const LOG_USER_FAILURE = 'LOG_USER_FAILURE';
export const LOG_USER_IN_PROGRESS = 'LOG_USER_IN_PROGRESS';
export const USER_UPDATE_TOKENS = 'USER_UPDATE_TOKENS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';
export const FETCH_PROFILE_IN_PROGRESS = 'FETCH_PROFILE_IN_PROGRESS';
export const SWITCH_TO_BACKOFFICE_SUCCESS = 'SWITCH_TO_BACKOFFICE_SUCCESS';
const SWITCH_TO_BACKOFFICE_ERROR = 'SWITCH_TO_BACKOFFICE_ERROR';


export function passwordLogin(
	email: string,
	password: string
): (dispatch: DispatchLogUser) => void {
	return async (dispatch: DispatchThunkAny) => {
		try {
			dispatch({
				type: LOG_USER_IN_PROGRESS,
				payload: { email },
			});
			const data = await fetchUserToken(email, password);
			const payload = {
				name: data.autohaus,
				access_token: data.access_token,
				refresh_token: data.refresh_token,
			};
			dispatch({ type: LOG_USER_SUCCESS, payload });
			dispatch(fetchProfile());
		} catch (error) {
			dispatch({
				type: LOG_USER_FAILURE,
				payload: error,
			});

			return error;
		}
	};
}

export function tokenLogin(
	refreshToken: string
): (dispatch: DispatchFetchProfile, getState: any) => void {
	return async (dispatch: DispatchFetchProfile, getState) => {
		try {
			dispatch({
				type: LOG_USER_IN_PROGRESS,
				payload: { email: '' },
			});
			const store: AppStore = { getState, dispatch };
			await refreshUserToken(refreshToken, store)
				.then((data) => {
					log('tokenLogin success', data);
					dispatch({ type: LOG_USER_SUCCESS, payload: data });
					dispatch(fetchProfile());
				})
				.catch((error) => {
					log('tokenLogin error', error);
					dispatch(logOutUser());
				});
		} catch (error) {
			log('tokenLogin error', error);
			dispatch(logOutUser());

			return error;
		}
	};
}

export function updateTokens(
	accessToken: string,
	refreshToken: string
): { type: string; payload: any } {
	return {
		type: USER_UPDATE_TOKENS,
		payload: { access_token: accessToken, refresh_token: refreshToken },
	};
}

export function logOutUser(): { type: string } {
	deleteCookieWithName("_pk_.*")
		return {
		type: LOGOUT_USER,
	};
}

function fetchProfile(): (
	dispatch: DispatchFetchProfile,
	getState: any
) => void {
	return async (dispatch: DispatchFetchProfile, getState: any) => {
		try {
			dispatch({ type: FETCH_PROFILE_IN_PROGRESS, });
			const store: AppStore = { getState, dispatch };
			const data = await fetchUserProfile(store);
			dispatch({ type: FETCH_PROFILE_SUCCESS, payload: data });
			dispatch(updateCustomizing(data.customizingid));
		} catch (error) {
			dispatch({
				type: FETCH_PROFILE_FAILURE,
				payload: error,
			});
			// no profile data -> nothing to customize
			dispatch({ type: FETCH_CUSTOMIZING_SUCCESS, payload: {} });

			return error;
		}
	};
}

export function switchToBackoffice(): (
	dispatch: DispatchThunkAny,
	getState: any
) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		try {
			const store: AppStore = { getState, dispatch };
			const data = await requestBackofficeSSO(store);
			dispatch({ type: SWITCH_TO_BACKOFFICE_SUCCESS, payload: data });
		} catch (error) {
			dispatch({
				type: SWITCH_TO_BACKOFFICE_ERROR,
				payload: error,
			});

			return error;
		}
	};
}
